import { initializeApp, getApps, getApp } from 'firebase/app';
import { getFirestore, collection } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyBIz_SHUjvXTTYqWmfizyoJAhyp2Y90wxc",
  authDomain: "issue-tracker-89f2f.firebaseapp.com",
  projectId: "issue-tracker-89f2f",
  storageBucket: "issue-tracker-89f2f.appspot.com",
  messagingSenderId: "118961811549",
  appId: "1:118961811549:web:8ef7a91b0711d1a9601db4",
  measurementId: "G-ZZNVHLS8N0"
};

// Initialize Firebase only if it hasn't been initialized yet
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export const clientAuth = auth;
export const clientDb = db;

export const usersCollection = collection(db, 'users');
export const rolesCollection = collection(db, 'roles');
export const permissionsCollection = collection(db, 'permissions');